import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { StoredProcedures } from 'src/app/core/models/stored-procedures';

@Component({
  selector: 'app-project-toolkit-stored-procedures-select',
  templateUrl: './project-toolkit-stored-procedures-select.html',
  styleUrls: ['./project-toolkit-stored-procedures-select.component.scss']
})
export class ProjectToolkitStoredProceduresSelectFilterComponent implements OnInit, OnChanges {

  @Input() public storedProcedures: StoredProcedures;
  @Input() public isLoading: boolean = false;
  @Input() public disabled: boolean = false;
  @Input() public filterPrefix: string = '';

  @Output() public emitSelectedItems = new EventEmitter<any>();

  @ViewChild('dropdownContainer') public dropdownContainer: ElementRef<HTMLElement>;

  public showDropdown: boolean = false;
  public searchInputValue: string = '';

  public get filteredStoredProcedures(): any[] {
    const all = this.storedProcedures?.allStoredProcedures || [];
    if (!this.filterPrefix) { return all; }
    return all.filter(sp => sp.objectName?.toLowerCase().startsWith(this.filterPrefix.toLowerCase()));
  }

  darkMode$: Observable<boolean>;


  constructor(
    private store: Store<{ darkMode: boolean }>
  ) {
    this.darkMode$ = store.select('darkMode');
  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      this.showDropdown &&
      changes.isLoading &&
      !changes.isLoading.firstChange &&
      changes.isLoading.previousValue === true &&
      changes.isLoading.currentValue === false
    ) {
      this.scrollDropdownBottomIntoView();
    }
  }

  public selectItem(item: any): void {
    this.showDropdown = false;
    this.storedProcedures.storedProcedure.objectName = item.objectName;
    this.emitSelectedItems.emit(item);
    this.scrollTriggerIntoView();
  }

  public toggleDropdown(): void {
    this.showDropdown = !this.showDropdown;
    if (this.showDropdown) {
      if (!this.isLoading && this.storedProcedures?.allStoredProcedures?.length) {
        this.scrollDropdownBottomIntoView();
      }
    } else {
      this.scrollTriggerIntoView();
    }
  }

  private scrollDropdownBottomIntoView(): void {
    setTimeout(() => {
      const container = this.dropdownContainer?.nativeElement;
      if (!container) {
        return;
      }
      const panel = container.querySelector('.dd-container') as HTMLElement | null;
      const target = panel ?? container;
      if (typeof target.scrollIntoView === 'function') {
        target.scrollIntoView({ behavior: 'smooth', block: 'end' });
      }
    }, 0);
  }

  private scrollTriggerIntoView(): void {
    setTimeout(() => {
      const container = this.dropdownContainer?.nativeElement;
      const trigger = container?.querySelector('button') as HTMLElement | null;
      const target = trigger ?? container;
      if (target && typeof target.scrollIntoView === 'function') {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 0);
  }

}
